import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { actions as cartActions } from '../../../Cart'
import { actions as checkoutActions } from '../..'
import { Input, Button, Icon, Tooltip } from 'loyal-react'
import '@loyal_molecules/tooltip.css'

const CouponContent = ({ children }) => {
  return (
    <div className='row product-brand py-2 px-2 border-bottom border-color-ui-3'>
      <div className='col-7 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'>
        Cupom de desconto:
        <div className='modal-question'>
          <Tooltip position='bottom'>
            <Icon iconName='icon_question' className='cursor' />
            <span className='custom-tooltiptext txt-left px-2 py-2'>
              <h4>Cupom de Desconto</h4>
              <p className='mt-2'>
                É o código promocional que dá direito a um desconto em sua
                compra.
              </p>
              <p className='mt-2'>
                Insira o código no campo abaixo e o valor será subtraído do
                total de sua compra. Caso tenha optado por parcelar o valor,
                verifique novamente o total de parcelas.
              </p>
            </span>
          </Tooltip>
        </div>
      </div>
      {children}
    </div>
  )
}
CouponContent.propTypes = {
  children: PropTypes.array
}

class Coupon extends React.Component {
  state = { isFormOpen: false, code: this.props.code || '' }

  componentWillMount () {
    this.props.clearCouponError()
  }

  handleOpenForm = () => this.setState({ isFormOpen: !this.state.isFormOpen })

  render () {
    if (this.props.code) {
      return (
        <CouponContent>
          <div className='col-5'>
            <div className='col-12 color-ui-2 txt-body-sm txt-font-body txt-right justify-content-center align-self-center'>
              <strong>{this.props.code}</strong>
            </div>
            <div
              onClick={this.props.removeCoupon}
              className='col-12 cursor txt-title-3 txt-body-sm txt-subtitle txt-font-body color-brand-1 txt-right justify-content-center align-selfe-center'
            >
              Alterar
            </div>
          </div>
        </CouponContent>
      )
    }

    if (this.state.isFormOpen) {
      return (
        <CouponContent>
          <div className='col-12 mt-2'>
            <div className='row'>
              <div className='col form-field pl-0 pr-half'>
                <Input
                  id='coupon'
                  name='coupon'
                  label='Inserir cupom de desconto'
                  className='col-12 pl-half'
                  value={this.state.code}
                  onChange={e => this.setState({ code: e.target.value })}
                  data-error='Não foi possível aplicar o cupom de desconto.'
                  valid={this.props.hasError ? false : null}
                />
              </div>
              <div className='col-auto pl-half txt-right justify-content-center align-selfe-center'>
                <Button
                  id='adding-Coupon'
                  className='btn-icon btn-featured btn-icon-only'
                  iconName='icon_check'
                  loading={this.props.isLoading}
                  disabled={!this.state.code}
                  onClick={() => this.props.updateCoupon(this.state.code)}
                />
              </div>
            </div>
          </div>
        </CouponContent>
      )
    }

    return (
      <CouponContent>
        <div
          onClick={this.handleOpenForm}
          className='col-5 cursor txt-title-3 txt-body-sm txt-subtitle txt-font-body color-brand-1 txt-right justify-content-center align-selfe-center'
        >
          Aplicar
        </div>
      </CouponContent>
    )
  }
}

Coupon.propTypes = {
  code: PropTypes.string,
  isLoading: PropTypes.bool,
  hasError: PropTypes.bool,
  updateCoupon: PropTypes.func,
  removeCoupon: PropTypes.func,
  clearCouponError: PropTypes.func
}

const mapStateToProps = ({ cart }) => ({ ...cart.coupon })

const mapDispatchToProps = dispatch => ({
  updateCoupon: code => dispatch(cartActions.updateCoupon(code)),
  removeCoupon: () => dispatch(cartActions.removeCoupon()),
  clearCouponError: () => dispatch(cartActions.clearCouponError()),
  fetchPointsCashConfig: () => dispatch(checkoutActions.fetchPointsCashConfig())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Coupon)



// WEBPACK FOOTER //
// ./src/features/Checkout/Summary/Coupon/Coupon.js